<template>
  <div class="container">
    <Modal v-model="importResultModal" title="导入结果">
      <div class="import-result-modal">
        <h3>
          成功导入{{
            importResultData ? importResultData.successImportCount : ""
          }}个，错误信息{{
            importResultData ? importResultData.errorData.length : ""
          }}个
        </h3>
        <div v-for="item in importResultList">
          {{ item }}
        </div>
      </div>
    </Modal>
    <div class="handle-wrapper">
      <div class="handle-left">
        <Input
          v-model="searchText"
          search
          placeholder="搜索客户..."
          @on-change="searchCustomer"
          clearable
          icon="ios-search"
          style="width: 230px; margin-right: 20px"
        >
        </Input>
      </div>
      <div class="handle-right">
        <div class="page-wrap">
          <span>共{{ totalRows }}条</span>
          <Page
            :total="totalRows"
            :page-size="20"
            @on-change="loadImportFileProcess"
            show-total
            simple
            style="margin-right: 24px"
          />
        </div>
        <Button
          type="info"
          @click="loadOutStoreInSalesStatMethod"
          style="margin-right: 12px"
          >出库单转入销售统计</Button
        >
        <Button
          @click="$refs.ImportFileModal.openModal()"
          style="margin-right: 12px"
          >Excel导入出库单</Button
        >
      </div>
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :columns="columns"
        :data="entityList"
        :height="tableHeight"
        :loading="tableLoading"
      ></Table>
    </div>
    <ImportFileModal
      ref="ImportFileModal"
      @importResult="openImportResultModal"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { arrayIntersection } from "@/utils";
import ImportFileModal from "./ImportFileModal.vue";
import _ from "lodash";
import dayjs from "dayjs";

const statusToText = {
  ckd: "出库单",
  thd: "退货单",
  k3ckd: "K3出库单",
  k3thd: "k3退货单",
};
export default {
  name: "ImportFileProcess",
  components: {
    ImportFileModal,
  },
  data() {
    return {
      tableHeight: 300,
      searchText: null,
      limit: 20,
      page: 0,
      tableLoading: false,
      importResultModal: false,
      importResultData: null,
      importResultList: null,
      filterQuery: {},
      columns: [
        {
          title: "客户",
          key: "customer",
          fixed: "left",
          minWidth: 190,
          render: (h, params) =>
            h("span", this.dataTransform(params.row.customer, "name")),
        },
        {
          title: "公司",
          key: "company",
          minWidth: 120,
          align: "left",
          render: (h, params) =>
            h(
              "span",
              params.row.company
                ? params.row.company.abbr
                  ? params.row.company.abbr
                  : params.row.company.name
                : ""
            ),
        },
        {
          title: "工厂",
          key: "factory",
          minWidth: 120,
          align: "left",
          render: (h, params) =>
            h("span", params.row.factory ? params.row.factory.name : ""),
        },
        {
          title: "导入时间",
          key: "importFromJDAt",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("span", dayjs(params.row.importFromJDAt).format("MM-DD")),
            ]);
          },
        },
        {
          title: "表单类型",
          minWidth: 110,
          key: "docType",
          align: "center",
          render: (h, params) => h("span", statusToText[params.row.docType]),
        },
        {
          title: "单据状态",
          minWidth: 110,
          key: "status",
          align: "center",
          render: (h, params) => h("span", params.row.docStatus),
        },
        {
          title: "日期",
          key: "docDate",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h("span", dayjs(params.row.docDate).format("MM-DD")),
            ]);
          },
        },
        {
          title: "金蝶单据编号",
          minWidth: 120,
          key: "JDDocNo",
          align: "center",
          render: (h, params) => h("span", params.row.JDDocNo),
        },
        {
          title: "物料编码",
          minWidth: 110,
          key: "itemCode",
          align: "center",
          render: (h, params) => h("span", params.row.itemCode),
        },
        {
          title: "物料名称",
          minWidth: 120,
          key: "itemName",
          align: "left",
          render: (h, params) =>
            h(
              "span",
              {
                style: {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
              },
              params.row.itemName
            ),
        },
        {
          title: "金蝶上客户",
          minWidth: 110,
          key: "JDCustomer",
          align: "left",
          render: (h, params) => h("span", params.row.JDCustomer),
        },
        {
          title: "发货组织",
          minWidth: 130,
          key: "shippingOrg",
          align: "left",
          render: (h, params) => h("span", params.row.shippingOrg),
        },
        {
          title: "规格型号",
          minWidth: 110,
          key: "model",
          align: "center",
          render: (h, params) => h("span", params.row.model),
        },
        {
          title: "库存单位",
          minWidth: 110,
          key: "unit",
          align: "center",
          render: (h, params) => h("span", params.row.unit),
        },
        {
          title: "仓库",
          minWidth: 110,
          key: "storage",
          align: "center",
          render: (h, params) => h("span", params.row.storage),
        },

        {
          title: "厂内实发",
          key: "volOutFactory",
          minWidth: 130,
          align: "right",
          render: (h, params) => h("span", params.row.volOutFactory),
        },
        {
          title: "客户实收",
          key: "volReceived",
          minWidth: 130,
          align: "right",
          render: (h, params) => h("span", params.row.volReceived),
        },
        {
          title: "含税单价",
          key: "price",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.price);
          },
        },
        {
          title: "金额",
          key: "preTaxSalesAmount",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.preTaxSalesAmount);
          },
        },
        {
          title: "价税合计",
          key: "salesAmount",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.salesAmount);
          },
        },
        {
          title: "车牌号",
          key: "plate",
          align: "right",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.plate);
          },
        },
        {
          title: "一级审核人",
          key: "firstVerifyUser",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.firstVerifyUser);
          },
        },
        {
          title: "二级审核人",
          key: "secondVerifyUser",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.secondVerifyUser);
          },
        },
        {
          title: "金蝶云备注",
          key: "remarkJD",
          minWidth: 150,
          align: "left",
          render: (h, params) => h("span", params.row.remarkJD),
        },
        {
          title: "销售人员",
          key: "salesPerson",
          align: "center",
          minWidth: 100,
          render: (h, params) => {
            return h("div", params.row.salesPerson);
          },
        },
        {
          title: "一级物料编码",
          key: "flvItemCode",
          minWidth: 100,
          align: "right",
          render: (h, params) => h("span", params.row.flvItemCode),
        },
        {
          title: "不含税价格",
          key: "preTaxPrice",
          minWidth: 150,
          align: "right",
          render: (h, params) => h("span", parseInt(params.row.preTaxPrice)),
        },
        {
          title: "收获吨数差",
          key: "volDiff",
          minWidth: 120,
          align: "right",
          render: (h, params) => h("span", params.row.volDiff),
        },
        {
          title: "每吨单价中的税",
          key: "taxOnPrice",
          minWidth: 120,
          align: "right",
          render: (h, params) => h("span", parseInt(params.row.taxOnPrice)),
        },
        {
          title: "销售产生的税",
          key: "tax",
          minWidth: 120,
          align: "right",
          render: (h, params) => h("span", parseInt(params.row.tax)),
        },
        {
          title: "内部关联交易",
          key: "internalShipping",
          minWidth: 110,
          align: "center",
          render: (h, params) => h("span", params.row.internalShipping),
        },
        {
          title: "创建人",
          key: "createdBy",
          minWidth: 110,
          align: "center",
          render: (h, params) => h("span", params.row.createdBy.name),
        },
      ],
    };
  },
  computed: mapState({
    user: (state) => state.auth.currentUser,
    entityList: (state) => state.outStore.entityList,
    totalRows: (state) => state.outStore.totalCounts,
  }),
  methods: {
    ...mapActions({
      getOutStore: "outStore/getOutStoreAction",
      loadOutStoreInSalesStat: "outStore/loadOutStoreInSalesStatAction",
    }),
    arrayIntersection(array, targetArray) {
      return arrayIntersection(array, targetArray);
    },
    dataTransform(params, item) {
      let value = null;
      if (params && params.abbr) {
        value = params.abbr;
      } else {
        value = _.get(params, item, "-");
      }
      return value;
    },
    async loadImportFileProcess(page) {
      if (page) this.page = page - 1;
      this.filterQuery = {
        ...this.filterQuery,
        limit: this.limit,
        skip: this.page * this.limit,
      };
      if (this.searchText) {
        this.filterQuery.cus_name = this.searchText;
      } else {
        delete this.filterQuery.cus_name;
      }
      try {
        this.tableLoading = true;
        const data = await this.getOutStore(this.filterQuery);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败：${error}`);
        this.tableLoading = false;
      }
    },
    async loadOutStoreInSalesStatMethod() {
      await this.loadOutStoreInSalesStat();
    },
    searchCustomer() {},
    openImportResultModal(e) {
      this.importResultModal = true;
      this.importResultData = e;
      this.importResultList = e.errorData;
    },
  },
  created() {
    this.loadImportFileProcess();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>
<style lang="stylus" scoped>
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content space-between

  .handle-left
    display flex
    align-items center

  .handle-right
    display flex
    align-items center

    .page-wrap
      display flex
      align-items center
      min-width 220px

.table-wrapper
  width 100%
  height calc(100% - 48px)

.import-result-modal
  height 265px
  overflow hidden
  overflow-y auto
</style>